import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { getSettings } from '../../settings/store';
import { SetTags, SetTitle } from '../../store';
import { StringUtility } from '@teamfoster/sdk/text-utility';

@Injectable({ providedIn: 'root' })
export class HomeMetaGuard {
  private store = inject(Store);


  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(getSettings).pipe(
      tap(settings => {
        this.store.dispatch(SetTitle({ title: `${settings!.homeMetaData.title}` }));
        this.store.dispatch(
          SetTags({
            properties: {
              'description': StringUtility.Truncate(StringUtility.StripHTML(settings!.homeMetaData.description), 157, '...'),
              'og:title': `${settings!.homeMetaData.title}`,
              'og:image': settings!.homeMetaData.imageUrl,
              'og:description': StringUtility.Truncate(StringUtility.StripHTML(settings!.homeMetaData.description), 157, '...'),
            },
          })
        );
      }),
      map(a => true),
      take(1)
    );
  }
}
